import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod, IResourceMethodStrict } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
import { ISubscriptions } from '../interfaces/ISubscriptions';

// Import RxJs required methods


@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api/subscriptions'
})
export class SubscriptionsService extends RestClient {
    @ResourceAction({
        path: '/mysubscriptions',
        isArray: true
    })
    getSubscriptions: IResourceMethod<{}, ISubscriptions>;

    @ResourceAction({
        path: '/mysubscriptions/{:userId}/{:token}',
        isArray: true,
        noAuth: true
    })
    getSubscriptionsToken: IResourceMethod<{}, ISubscriptions>;

    @ResourceAction({
        path: '/mysubscriptions',
        method: ResourceRequestMethod.Post
    })
    saveSubscriptions: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/mysubscriptions/{:userId}/{:token}',
        method: ResourceRequestMethod.Post,
        noAuth: true
    })
    saveSubscriptionsToken: IResourceMethodStrict<any, { userId: any, token: any }, any, null>;
}

